import { Stack, Box, styled, AccordionDetails } from "@schaeffler-commerce/design-system";

export const ShowAllLess = styled(Stack)(({ theme }) => ({
  position: "absolute",
  bottom: "10px",
  cursor: "pointer",
  color: theme.palette.primary.main,
  gap: 0.5,
  flexDirection: "row",
  alignItems: "center",
}));

export const PCTableContainer = styled(Box)(({ theme }) => ({
  "& thead": {
    display: "none",
  },
  "& .TanStackTable-tableContainer": {
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  ".TanStackTable-tableContainer .TanStackTable-table.productComparison": {
    [theme.breakpoints.down("desktop-l")]: {
      width: "246px",
    },
  },
}));

export const PCAccordionDetails = styled(AccordionDetails)(({ theme: _theme }) => ({
  padding: "0",
  paddingBottom: "12px",
}));
